<template>
    <div class="member-order-list">
        <div class="common-header-wrap">
            <mt-header title="Order List" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>
        <!-- header -->
        <div class="order-header">
            <ul>
                <li
                        class="item"
                        v-for="item in orderNav"
                        v-bind:key="item.id"
                        v-bind:class="{ active: stateType == item.id }"
                        v-on:click="setOrderNavActive(item.id)"
                >
                    {{ item.name }}
                </li>
            </ul>
        </div>
        <div v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
            <div class="order-body" v-if="order_list && order_list.length">
                <div class="list" v-for="item in order_list" :key="item.chain_order_id">
                    <div @click="$router.push({name:'ChainOrderDetail',query:{chain_order_id:item.chain_order_id}})">
                        <div class="tips-body">
                            <span class="tips"> Order number: {{ item.order_sn }} </span>
                            <span class="title tips statusTips" >
						{{ item.state_desc }}
					</span>
                        </div>
                        <div
                                class="order-image"
                                v-if="item.goods_list.length > 0"
                        >
                            <img
                                    v-bind:src="image.image_240_url"
                                    v-for="image in item.goods_list"
                            />

                        </div>

                    </div>
                    <div class="order-list-opratio">
                        <!-- 锁定-->
                        <button v-if="item.chain_order_lock_state">Refunding</button>
                        <!-- 物流跟踪 -->
                        <button v-if="item.chain_order_shipping_code" v-on:click="deliver(item.chain_order_id)">Logistics tracking</button>
                        <!-- 取货 -->
                        <button v-if="!item.chain_order_lock_state && item.chain_order_state==35" v-on:click="chainPickup(item)">{{item.payment_code=='offline'?'Received':'Picked up'}}</button>
                        <!-- 到站 -->
                        <button v-if="!item.chain_order_lock_state && item.chain_order_state==30" v-on:click="chainArrive(item.chain_order_id)" class="line_red">Arrived</button>
                    </div>
                </div>
            </div>
            <empty-record v-else-if="order_list && !order_list.length"></empty-record>
        </div>
    </div>
</template>

<script>
import { getChainOrderList, chainArrive, chainPickup } from '../../../api/chainManage'
import { Toast, MessageBox, Indicator } from 'mint-ui'
import { mapState } from 'vuex'
import EmptyRecord from '../../../components/EmptyRecord'
export default {
  components: {
    EmptyRecord
  },
  name: 'MemberOrderList',
  data () {
    return {
      order_id: 0,

      orderNav: [
        {
          'name': 'All',
          'id': ''
        },
        {
          'name': 'Not arrived',
          'id': 'state_default'
        },
        {
          'name': 'To be mentioned',
          'id': 'state_arrive'
        },
        {
          'name': 'Picked up',
          'id': 'state_pickup'
        }
      ],
      params: { 'page': 0, 'per_page': 10 },
      loading: false, // 是否加载更多
      isMore: true, // 是否有更多
      stateType: this.$route.query.state ? this.$route.query.state : '',
      orderDetailVisible: false,
      wrapperHeight: 0,
      order_list: false
    }
  },

  mounted () {
    this.wrapperHeight = document.documentElement.clientHeight - 140
  },
  computed: {
    ...mapState({
      user: state => state.member.info
    })
  },
  created: function () {
  },

  methods: {
    deliver (orderId) {
      this.$router.push({ name: 'ChainOrderDeliver', query: { order_id: orderId } })
    },
    chainPickup (order) {
      if (order.payment_code == 'offline') {
        MessageBox.confirm('Are you sure you have received the payment of ' + order.goods_list[0].goods_pay_price + ' dollars？').then(action => {
          this.goPickup(order.chain_order_id)
        })
      } else {
        this.goPickup(order.chain_order_id)
      }
    },
    goPickup (orderId) {
      MessageBox.prompt('Please fill in the pickup code', '').then(({ value, action }) => {
        chainPickup(orderId, value).then(res => {
          this.reload()
        }).catch(function (error) {
          Toast(error.message)
        })
      })
    },
    setOrderNavActive (index) {
      this.stateType = index
      this.getOrderList(true)
    },

    chainArrive (orderId) {
      MessageBox.confirm('Are you sure that the order has arrived?').then(action => {
        chainArrive(orderId).then(res => {
          this.reload()
        }).catch(function (error) {
          Toast(error.message)
        })
      })
    },

    loadMore () {
      this.loading = true
      this.params.page = ++this.params.page
      if (this.isMore) {
        this.loading = false
        this.getOrderList(false)
      }
    },
    reload () {
      // 重新加载数据
      this.params.page = 0
      this.isMore = true
      this.order_list = []
      this.loadMore()
    },
    getOrderList (ifReplace) {
      Indicator.open()
      if (ifReplace) {
        this.loading = false
        this.params.page = 1
        this.isMore = true
      }

      getChainOrderList(this.params, '', this.stateType).then(res => {
        Indicator.close()
        if (res.result.hasmore) {
          this.isMore = true
        } else {
          this.isMore = false
        }

        let tOrderList = res.result.chain_order_list

        if (tOrderList) {
          if (ifReplace || !this.order_list) {
            this.order_list = tOrderList
          } else {
            this.order_list = this.order_list.concat(tOrderList)
          }
        }
      }).catch(function (error) {
        Indicator.close()
        Toast(error.message)
      })
    }
  }
}
</script>
<style  lang="scss" scoped>
    .member-order-list {
        .order-header {
            position: fixed;
            height: 2.2rem;
            width: 100%;
            top: 2rem;
            z-index: 100;
            ul {
                list-style: none;
                width: auto;
                display: flex;
                justify-content: space-around;
                align-content: center;
                align-items: center;
                height: 100%;
                background: rgba(255, 255, 255, 1);
                border-bottom: 1px solid #e8eaed;
                li {
                    font-size: 0.7rem;
                    color: rgba(124, 127, 136, 1);
                    height: 100%;
                    text-align: center;
                    line-height: 2.2rem;
                    border-bottom: 0.1rem solid transparent;
                    &.active {
                        color: $primaryColor;
                        border-bottom-color: $primaryColor;
                    }
                }
            }
        }
        .order-body {
            position:relative;padding-top:2.3rem;
            .list {
                width: 100%;
                margin-top: 0.55rem;
                .tips-body {
                    height: 2.2rem;
                    background: rgba(255, 255, 255, 1);
                    box-shadow: 0 1px 0 0 rgba(232, 234, 237, 1);
                    display: flex;
                    justify-content: space-between;
                    padding: 0 0.75rem 0 0.5rem;
                    .tips {
                        font-size: 0.7rem;
                        color: #333333;
                        line-height: 2.2rem;
                    }
                    .statusTips {
                        color: #666666;
                    }
                    img {
                        width: 3.8rem;
                        height: 3rem;
                    }
                }
                .order-image {
                    height: 4.55rem;
                    background: rgba(250, 250, 250, 1);
                    width: 100%;
                    overflow: auto;
                    white-space: nowrap;
                    img {
                        width: 3rem;
                        height: 3rem;
                        border-radius: 1px;
                        margin: 0.85rem 0.5rem 0.5rem;
                    }
                }

            }
            .loading-wrapper {
                text-align: center;
                p {
                    color: #c3c3c3;
                    font-size: 0.6rem;
                    font-weight: 'Regular';
                    margin: 0.5rem auto;
                }
            }
        }
        .mint-popup {
            width: 100%;
            height: 11.75rem;
        }
    }
    .order-list-opratio{height: 2.45rem;display: flex;justify-content: flex-end;background: rgba(255, 255, 255, 1);border-radius: 0.1rem;}
    .order-list-opratio button{width: 4.5rem;height: 1.8rem;font-size: 0.7rem;border-radius: 0.7rem;margin: 0.35rem 0.75rem 0.35rem 0;background-color: #fff;border: 1px solid #ccc;box-shadow: 0 3px 6px 0 rgba(0,0,0,.05);}
    .order-list-opratio .line_red{background-color: #fff;color: #f2270c;border: 1px solid #f2270c;box-shadow: 0 3px 6px 0 rgba(242,39,12,.1);}
</style>
